import axios from 'axios'

const analyticsPage = (name = '', properties = {}) => {
  try {
    window.analytics.page(name, properties)
  } catch (error) {
    trackAnalyticsError(error)
  }
}

const analyticsTrack = (event = '', properties = {}) => {
  try {
    window.analytics.track(event, properties)
  } catch (error) {
    trackAnalyticsError(error)
  }
}

const analyticsIdentify = (userId = '', traits = {}) => {
  try {
    window.analytics.identify(userId.toString(), traits)
  } catch (error) {
    trackAnalyticsError(error)
  }
}

const trackAnalyticsError = async error => {
  try {
    await axios.post('/ali/track-analytics-error', { error })
  } catch (error) {
    console.log('failed to track analytics error')
  }
}

export { analyticsPage, analyticsTrack, analyticsIdentify }
